import BaseState from "Engine/base/states/BaseState";
import GlobalDispatcher from "Engine/events/GlobalDispatcher";

export default class ShowLinesWinningState extends BaseState {
    constructor(stateData) {
        super(stateData);
    }

    start() {
        super.start();
        this.complete();
    }
}